import React, { FC } from 'react'

import s from './WixMobileHeading.scss'

interface WixMobileHeadingProps {
  dataHook?: string
}

export const WixMobileHeading: FC<WixMobileHeadingProps> = ({ children, dataHook }) => (
  <h1 className={s.heading} data-hook={dataHook}>
    {children}
  </h1>
)
